import lang from '@/lang'
import {
  LOG_AE_AIR_BOOKING,
  LOG_AE_AIR_BOOKING_BASIC,
  LOG_AE_AIR_BOOKING_BASIC_AIR_ULD,
  LOG_SE_SEA_BOOKING,
  LOG_SE_SEA_BOOKING_BASIC,
  LOG_SE_SEA_BOOKING_BASIC_CARGO_BULK_DETAIL,
  LOG_SE_SEA_BOOKING_BASIC_SEA_EQ,
  LOG_SE_SEA_BOOKING_CHARGE,
  LOG_SI_SEA_BOOKING,
  LOG_SI_SEA_BOOKING_BASIC,
  LOG_SI_SEA_BOOKING_BASIC_SEA_EQ,
  LOG_SI_SEA_BOOKING_BASIC_CARGO_BULK_DETAIL,
  LOG_AI_AIR_BOOKING,
  LOG_AI_AIR_BOOKING_MASTER_INFO,
  LOG_AI_AIR_BOOKING_AIR_OPERATION,
  LOG_RE_RAILWAY_BOOKING,
  LOG_RE_RAILWAY_BOOKING_BASIC,
  LOG_RE_RAILWAY_BOOKING_BASIC_SEA_EQ,
  LOG_RE_RAILWAY_BOOKING_BASIC_SEA_EQ2,
  LOG_AE_AIR_BOOKING_CHARGE,
  LOG_SI_SEA_BOOKING_CHARGE,
  LOG_AI_AIR_BOOKING_CHARGE,
  LOG_RE_RAILWAY_BOOKING_CHARGE,
  LOG_CARRY_FORWARD_CHARGE,
  LOG_FINANCIAL_REVIEW_CHARGE,
  LOG_SE_SEA_BOOKING_CHARGE_ADVANCE,
  LOG_SI_SEA_BOOKING_CHARGE_ADVANCE,
  LOG_AE_AIR_BOOKING_CHARGE_ADVANCE,
  LOG_AI_AIR_BOOKING_CHARGE_ADVANCE,
  LOG_RE_RAILWAY_BOOKING_CHARGE_ADVANCE,
  LOG_CARRY_FORWARD_CHARGE_ADVANCE,
  LOG_FINANCIAL_REVIEW_CHARGE_ADVANCE,
  LOG_RECONCILIATION_CHARGE,
  LOG_RECONCILIATION_CHARGE_ADVANCE,
  LOG_MAKE_INVOICE_CHARGE,
  LOG_MAKE_INVOICE_CHARGE_ADVANCE,
  LOG_BILL_PAYMENT_CHARGE,
  LOG_BILL_PAYMENT_CHARGE_ADVANCE,
  LOG_WRITE_OFF_CHARGE,
  LOG_WRITE_OFF_CHARGE_ADVANCE,
  LOG_OPERATION_TYPE_DELETE,
  LOG_OPERATION_TYPE_ADD,
  LOG_OPERATION_TYPE_UPDATE,
  LOG_API_CALL_BACK_CHARGE,
  LOG_API_CALL_BACK_CHARGE_ADVANCE,
  LOG_BWJS_CHARGE,
  LOG_BWJS_CHARGE_ADVANCE,
  LOG_NUONUO_CHARGE,
  LOG_AISINO_EI_CHARGE,
  LOG_TAX_EASY_CHARGE,
  LOG_TAX_EASY_CHARGE_ADVANCE,
  LOG_YGSH_CHARGE,
  LOG_YGSH_CHARGE_ADVANCE,
  LOG_BAI_HUI_CHARGE,
  LOG_BAI_HUI_CHARGE_ADVANCE,
  LOG_CLAIM_BANK_RECEIPT_CHARGE,
  LOG_CLAIM_BANK_RECEIPT_CHARGE_ADVANCE,
  LOG_OVERSEAS_SETTLEMENT_CENTER_CHARGE_ADVANCE,
  LOG_OVERSEAS_SETTLEMENT_CENTER_CHARGE,
  LOG_CHARGE_IMPORT_CHARGE,
  LOG_CHARGE_IMPORT_CHARGE_ADVANCE,
  LOG_FROM_IMPORT_BASIC,
  LOG_FROM_IMPORT_BASIC_SEA_EQ,
  LOG_FROM_IMPORT_BASIC_CARGO_BULK_DETAIL,
  LOG_FROM_IMPORT_CHARGE,
  LOG_FROM_IMPORT_CHARGE_ADVANCE,
  LOG_FROM_EXPORT_BASIC,
  LOG_FROM_EXPORT_BASIC_SEA_EQ,
  LOG_FROM_EXPORT_BASIC_CARGO_BULK_DETAIL,
  LOG_FROM_EXPORT_CHARGE,
  LOG_FROM_EXPORT_CHARGE_ADVANCE,
  LOG_SE_SEA_BOOKING_FILE_HISTORY,
  LOG_AE_SEA_BOOKING_FILE_HISTORY,
  LOG_SI_SEA_BOOKING_FILE_HISTORY,
  LOG_AI_SEA_BOOKING_FILE_HISTORY,
  LOG_RE_SEA_BOOKING_FILE_HISTORY,
  LOG_AE_AIR_BOOKING_API,
  LOG_SE_SEA_BOOKING_BASIC_TRANSPORTATION_METHOD,
  LOG_BOOKING_CUSTOM_FORM
} from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getActionLogAttribute } from '@/utils/ActionLogAttributeConstants'
import { queryUiCustomNameByKeys } from '@/api/sysManage/aiCustomPage'

const operationSourceNameMap = new Map([
  // ---------- 海出 -----------
  [LOG_SE_SEA_BOOKING.code, { 'fullName': lang.t('CargoMsg.Cargo_OceanExport') }],
  [LOG_SE_SEA_BOOKING_BASIC.code, { 'simpleName': lang.t('CargoMsg.Cargo_Basic'), 'fullName': lang.t('CargoMsg.Cargo_OceanExport') + '>' + lang.t('CargoMsg.Cargo_Basic') }],
  [LOG_SE_SEA_BOOKING_BASIC_SEA_EQ.code, { 'simpleName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    const eqType = item.operationParams.split('\n')[1]
    return lang.t('CargoMsg.Cargo_Basic') + '---->' + lang.t('SeaExport.BoxType') + '(' + eqSizeLabel + eqType + ')'
  }, 'fullName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    const eqType = item.operationParams.split('\n')[1]
    return lang.t('CargoMsg.Cargo_OceanExport') + '>' + lang.t('CargoMsg.Cargo_Basic') + '>' + lang.t('SeaExport.BoxType') + '(' + eqSizeLabel + eqType + ')'
  }
  }],
  [LOG_SE_SEA_BOOKING_BASIC_CARGO_BULK_DETAIL.code, { 'simpleName': lang.t('CargoMsg.Cargo_Basic') + '---->' + lang.t('CargoMsg.Cargo_BulkCargo'), 'fullName': lang.t('CargoMsg.Cargo_OceanExport') + '>' + lang.t('CargoMsg.Cargo_Basic') + '>' + lang.t('CargoMsg.Cargo_BulkCargo') }],
  [LOG_SE_SEA_BOOKING_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_OceanExport'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_OceanExport'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_SE_SEA_BOOKING_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_OceanExport'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_OceanExport'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  [LOG_SE_SEA_BOOKING_FILE_HISTORY.code, {
    'simpleName': async(item) => {
      return lang.t('CargoMsg.Cargo_FileHistory')
    }, 'fullName': async(item) => {
      return lang.t('CargoMsg.Cargo_OceanExport') + '>' + lang.t('CargoMsg.Cargo_FileHistory')
    }
  }],
  [LOG_AE_SEA_BOOKING_FILE_HISTORY.code, {
    'simpleName': async(item) => {
      return lang.t('CargoMsg.Cargo_FileHistory')
    }, 'fullName': async(item) => {
      return lang.t('CargoMsg.Cargo_AirExport') + '>' + lang.t('CargoMsg.Cargo_FileHistory')
    }
  }],
  [LOG_SI_SEA_BOOKING_FILE_HISTORY.code, {
    'simpleName': async(item) => {
      return lang.t('CargoMsg.Cargo_FileHistory')
    }, 'fullName': async(item) => {
      return lang.t('CargoMsg.Cargo_OceanImport') + '>' + lang.t('CargoMsg.Cargo_FileHistory')
    }
  }],
  [LOG_AI_SEA_BOOKING_FILE_HISTORY.code, {
    'simpleName': async(item) => {
      return lang.t('CargoMsg.Cargo_FileHistory')
    }, 'fullName': async(item) => {
      return lang.t('CargoMsg.Cargo_AirImport') + '>' + lang.t('CargoMsg.Cargo_FileHistory')
    }
  }],
  [LOG_RE_SEA_BOOKING_FILE_HISTORY.code, {
    'simpleName': async(item) => {
      return lang.t('CargoMsg.Cargo_FileHistory')
    }, 'fullName': async(item) => {
      return lang.t('CargoMsg.Cargo_RailwayBusiness') + '>' + lang.t('CargoMsg.Cargo_FileHistory')
    }
  }],
  [LOG_SE_SEA_BOOKING_BASIC_TRANSPORTATION_METHOD.code, { 'simpleName': lang.t('CargoMsg.Cargo_Basic') + '---->' + lang.t('SeaExport.TransshipmentTransportationMethod'), 'fullName': lang.t('SeaExport.TransshipmentTransportationMethod') + '>' + lang.t('CargoMsg.Cargo_Basic') + '>' + lang.t('SeaExport.TransshipmentTransportationMethod') }],

  // ---------- 空出 -----------
  [LOG_AE_AIR_BOOKING.code, { 'fullName': lang.t('CargoMsg.Cargo_AirExport') }],
  [LOG_AE_AIR_BOOKING_BASIC.code, { 'simpleName': lang.t('CargoMsg.Cargo_Basic'), 'fullName': lang.t('CargoMsg.Cargo_AirExport') + '>' + lang.t('CargoMsg.Cargo_Basic') }],
  [LOG_AE_AIR_BOOKING_BASIC_AIR_ULD.code, { 'simpleName': async(item) => {
    return lang.t('CargoMsg.Cargo_Basic') + '---->' + lang.t('CargoMsg.cargo_container_code') + '(' + item.operationParams + ')'
  }, 'fullName': async(item) => {
    return lang.t('CargoMsg.Cargo_AirExport') + '>' + lang.t('CargoMsg.Cargo_Basic') + '>' + lang.t('CargoMsg.cargo_container_code') + '(' + item.operationParams + ')'
  }
  }],
  [LOG_AE_AIR_BOOKING_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_AirExport'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_AirExport'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_AE_AIR_BOOKING_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_AirExport'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_AirExport'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  [LOG_AE_AIR_BOOKING_API.code, { 'simpleName': lang.t('CargoMsg.Cargo_ExternalInterface'), 'fullName': lang.t('CargoMsg.Cargo_AirExport') + '>' + lang.t('CargoMsg.Cargo_ExternalInterface') }],
  // ---------- 海进 -----------
  [LOG_SI_SEA_BOOKING.code, { 'fullName': lang.t('CargoMsg.Cargo_OceanImport') }],
  [LOG_SI_SEA_BOOKING_BASIC.code, { 'simpleName': lang.t('SeaExport.ImportOperation'), 'fullName': lang.t('CargoMsg.Cargo_OceanImport') + '>' + lang.t('SeaExport.ImportOperation') }],
  [LOG_SI_SEA_BOOKING_BASIC_SEA_EQ.code, { 'simpleName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    const eqType = item.operationParams.split('\n')[1]
    return lang.t('SeaExport.ImportOperation') + '(' + lang.t('CargoMsg.Cargo_OceanImport') + ')---->' + lang.t('SeaExport.BoxType') + '(' + eqSizeLabel + eqType + ')'
  }, 'fullName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    const eqType = item.operationParams.split('\n')[1]
    return lang.t('CargoMsg.Cargo_OceanImport') + '>' + lang.t('SeaExport.ImportOperation') + '>' + lang.t('SeaExport.BoxType') + '(' + eqSizeLabel + eqType + ')'
  }
  }],
  [LOG_SI_SEA_BOOKING_BASIC_CARGO_BULK_DETAIL.code, { 'simpleName': lang.t('SeaExport.ImportOperation') + '---->' + lang.t('CargoMsg.Cargo_BulkCargo'), 'fullName': lang.t('CargoMsg.Cargo_OceanImport') + '>' + lang.t('SeaExport.ImportOperation') + '>' + lang.t('CargoMsg.Cargo_BulkCargo') }],
  [LOG_SI_SEA_BOOKING_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_OceanImport'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_OceanImport'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_SI_SEA_BOOKING_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_OceanImport'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_OceanImport'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 空进 -----------
  [LOG_AI_AIR_BOOKING.code, { 'fullName': lang.t('CargoMsg.Cargo_AirImport') }],
  [LOG_AI_AIR_BOOKING_MASTER_INFO.code, { 'simpleName': lang.t('SeaExport.MblInfo'), 'fullName': lang.t('CargoMsg.Cargo_AirImport') + '>' + lang.t('SeaExport.MblInfo') }],
  [LOG_AI_AIR_BOOKING_AIR_OPERATION.code, { 'simpleName': lang.t('SeaExport.AirOperation'), 'fullName': lang.t('CargoMsg.Cargo_AirImport') + '>' + lang.t('SeaExport.AirOperation') }],
  [LOG_AI_AIR_BOOKING_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_AirImport'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_AirImport'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_AI_AIR_BOOKING_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_AirImport'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_AirImport'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 铁路业务 -----------
  [LOG_RE_RAILWAY_BOOKING.code, { 'fullName': lang.t('CargoMsg.Cargo_RailwayBusiness') }],
  [LOG_RE_RAILWAY_BOOKING_BASIC.code, { 'simpleName': lang.t('CargoMsg.Cargo_Basic'), 'fullName': lang.t('CargoMsg.Cargo_RailwayBusiness') + '>' + lang.t('CargoMsg.Cargo_Basic') }],
  [LOG_RE_RAILWAY_BOOKING_BASIC_SEA_EQ.code, { 'simpleName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    const eqType = item.operationParams.split('\n')[1]
    return lang.t('CargoMsg.Cargo_Basic') + '---->' + lang.t('SeaExport.BoxType') + '(' + eqSizeLabel + eqType + ')'
  }, 'fullName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    const eqType = item.operationParams.split('\n')[1]
    return lang.t('CargoMsg.Cargo_RailwayBusiness') + '>' + lang.t('CargoMsg.Cargo_Basic') + '>' + lang.t('SeaExport.BoxType') + '(' + eqSizeLabel + eqType + ')'
  }
  }],
  [LOG_RE_RAILWAY_BOOKING_BASIC_SEA_EQ2.code, { 'simpleName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    return lang.t('SeaExport.ImportOperation') + '---->' + lang.t('SeaExport.BoxModel') + '(' + eqSizeLabel + ')'
  }, 'fullName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    return lang.t('CargoMsg.Cargo_RailwayBusiness') + '>' + lang.t('SeaExport.ImportOperation') + '>' + lang.t('SeaExport.BoxModel') + '(' + eqSizeLabel + ')'
  }
  }],
  [LOG_RE_RAILWAY_BOOKING_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_RailwayBusiness'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_RailwayBusiness'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_RE_RAILWAY_BOOKING_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_RailwayBusiness'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_RailwayBusiness'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 结转 -----------
  [LOG_CARRY_FORWARD_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_CarryForward'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_CarryForward'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_CARRY_FORWARD_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_CarryForward'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_CarryForward'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 财务审核 -----------
  [LOG_FINANCIAL_REVIEW_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_FinancialAudit'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_FinancialAudit'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_FINANCIAL_REVIEW_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_FinancialAudit'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_FinancialAudit'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 对账 -----------
  [LOG_RECONCILIATION_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_Reconciliation'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_Reconciliation'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_RECONCILIATION_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_Reconciliation'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_Reconciliation'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 开票 -----------
  [LOG_MAKE_INVOICE_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_Invoicing'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_Invoicing'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_MAKE_INVOICE_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_Invoicing'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_Invoicing'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 开票 -----------
  [LOG_BILL_PAYMENT_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_PaymentRequest'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_PaymentRequest'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_BILL_PAYMENT_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_PaymentRequest'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_PaymentRequest'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  [LOG_API_CALL_BACK_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_ApiCallBack'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_ApiCallBack'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_API_CALL_BACK_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_ApiCallBack'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_ApiCallBack'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  [LOG_BWJS_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_BWJS'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_BWJS'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_BWJS_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_BWJS'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_BWJS'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  [LOG_NUONUO_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_NuoNuo'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_NuoNuo'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_AISINO_EI_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_AISINO_EI'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_AISINO_EI'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_TAX_EASY_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_TaxEasy'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_TaxEasy'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_TAX_EASY_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_TaxEasy'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_TaxEasy'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  [LOG_YGSH_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_YGSH'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_YGSH'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_YGSH_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_YGSH'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_YGSH'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  [LOG_BAI_HUI_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_BaiHui'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_BaiHui'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_BAI_HUI_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_BaiHui'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_BaiHui'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 销账 -----------
  [LOG_WRITE_OFF_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_WriteOff'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_WriteOff'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_WRITE_OFF_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_WriteOff'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_WriteOff'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 水单认领 -----------
  [LOG_CLAIM_BANK_RECEIPT_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_ClaimBankReceipt'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_ClaimBankReceipt'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_CLAIM_BANK_RECEIPT_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_ClaimBankReceipt'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_ClaimBankReceipt'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 海外结算中心 -----------
  [LOG_OVERSEAS_SETTLEMENT_CENTER_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_OverseasSettlementCenter'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_OverseasSettlementCenter'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_OVERSEAS_SETTLEMENT_CENTER_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_OverseasSettlementCenter'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_OverseasSettlementCenter'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 业务-费用导入 -----------
  [LOG_CHARGE_IMPORT_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('SeaExport.ChargeImport'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('SeaExport.ChargeImport'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_CHARGE_IMPORT_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('SeaExport.ChargeImport'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('SeaExport.ChargeImport'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 出口转进口的业务，【被同步方】的位置 -----------
  // ---------- 海出业务 -----------
  [LOG_FROM_IMPORT_BASIC.code, { 'simpleName': lang.t('CargoMsg.Cargo_Basic') + '(' + lang.t('CargoMsg.Cargo_From_Import') + ')', 'fullName': lang.t('CargoMsg.Cargo_From_Import') + '>' + lang.t('CargoMsg.Cargo_Basic') }],
  [LOG_FROM_IMPORT_BASIC_SEA_EQ.code, { 'simpleName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    const eqType = item.operationParams.split('\n')[1]
    return lang.t('CargoMsg.Cargo_Basic') + '(' + lang.t('CargoMsg.Cargo_From_Import') + ')---->' + lang.t('SeaExport.BoxType') + '(' + eqSizeLabel + eqType + ')'
  }, 'fullName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    const eqType = item.operationParams.split('\n')[1]
    return lang.t('CargoMsg.Cargo_From_Import') + '>' + lang.t('CargoMsg.Cargo_Basic') + '>' + lang.t('SeaExport.BoxType') + '(' + eqSizeLabel + eqType + ')'
  }
  }],
  [LOG_FROM_IMPORT_BASIC_CARGO_BULK_DETAIL.code, { 'simpleName': lang.t('CargoMsg.Cargo_Basic') + '(' + lang.t('CargoMsg.Cargo_From_Import') + ')---->' + lang.t('CargoMsg.Cargo_BulkCargo'), 'fullName': lang.t('CargoMsg.Cargo_From_Import') + '>' + lang.t('CargoMsg.Cargo_Basic') + '>' + lang.t('CargoMsg.Cargo_BulkCargo') }],
  [LOG_FROM_IMPORT_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_From_Import'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_From_Import'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_FROM_IMPORT_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_From_Import'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_From_Import'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 出口转进口的业务，【被同步方】的位置 -----------
  // ---------- 海进业务 -----------
  [LOG_FROM_EXPORT_BASIC.code, { 'simpleName': lang.t('SeaExport.ImportOperation') + '(' + lang.t('CargoMsg.Cargo_From_Export') + ')', 'fullName': lang.t('CargoMsg.Cargo_From_Export') + '>' + lang.t('SeaExport.ImportOperation') }],
  [LOG_FROM_EXPORT_BASIC_SEA_EQ.code, { 'simpleName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    const eqType = item.operationParams.split('\n')[1]
    return lang.t('SeaExport.ImportOperation') + '(' + lang.t('CargoMsg.Cargo_From_Export') + ')---->' + lang.t('SeaExport.BoxType') + '(' + eqSizeLabel + eqType + ')'
  }, 'fullName': async(item) => {
    const eqSize = item.operationParams.split('\n')[0]
    const attribute = getActionLogAttribute('seaEq.EQSIZE')
    const eqSizeLabel = await attribute.labelFunc(eqSize)
    const eqType = item.operationParams.split('\n')[1]
    return lang.t('CargoMsg.Cargo_From_Export') + '>' + lang.t('SeaExport.ImportOperation') + '>' + lang.t('SeaExport.BoxType') + '(' + eqSizeLabel + eqType + ')'
  }
  }],
  [LOG_FROM_EXPORT_BASIC_CARGO_BULK_DETAIL.code, { 'simpleName': lang.t('SeaExport.ImportOperation') + '(' + lang.t('CargoMsg.Cargo_From_Export') + ')---->' + lang.t('CargoMsg.Cargo_BulkCargo'), 'fullName': lang.t('CargoMsg.Cargo_From_Export') + '>' + lang.t('SeaExport.ImportOperation') + '>' + lang.t('CargoMsg.Cargo_BulkCargo') }],
  [LOG_FROM_EXPORT_CHARGE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_Cost'), lang.t('CargoMsg.Cargo_From_Export'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_From_Export'), lang.t('CargoMsg.Cargo_Cost'))
  }
  }],
  [LOG_FROM_EXPORT_CHARGE_ADVANCE.code, { 'simpleName': async(item) => {
    return chargeSimpleName(item, lang.t('CargoMsg.Cargo_AdvanceChargeInfo'), lang.t('CargoMsg.Cargo_From_Export'))
  }, 'fullName': async(item) => {
    return chargeFullName(item, lang.t('CargoMsg.Cargo_From_Export'), lang.t('CargoMsg.Cargo_AdvanceChargeInfo'))
  }
  }],
  // ---------- 自定义表单 -----------
  [LOG_BOOKING_CUSTOM_FORM.code, {
    'simpleName': item => item.operationJson && item.operationJson.customFormName ? item.operationJson.customFormName : lang.t('queryJob.CustomFormBusinessBooking'),
    'fullName': item => item.operationJson && item.operationJson.customFormName ? item.operationJson.customFormName : lang.t('queryJob.CustomFormBusinessBooking')
  }]
])

export function chargeSimpleName(item, param1, param2) {
  const chargeItemId = item.operationParams.split('\n')[0]
  const chargeName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', chargeItemId, 'zhName')
  const chargeId = item.operationParams.split('\n')[1]
  return param1 + '(' + param2 + ')---->' + chargeName + '(' + chargeId + ')'
}

export function chargeFullName(item, param1, param2) {
  const chargeItemId = item.operationParams.split('\n')[0]
  const chargeName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', chargeItemId, 'zhName')
  const chargeId = item.operationParams.split('\n')[1]
  return param1 + '>' + param2 + '>' + chargeName + '(' + chargeId + ')'
}

export class ActionLogUtil {
  /**
   * 解析operationJson参数
   * @param actionLogs
   * @returns
   */
  static async analyseOperationJson(actionLogs) {
    const customFormKeys = []
    for (const actionLog of actionLogs) {
      if (actionLog.operationParams) {
        const lines = actionLog.operationParams.split('\n')
        const newLines = []
        for (const line of lines) {
          if (line.startsWith('json:')) {
            actionLog.operationJson = JSON.parse(line.substring(5))
          } else {
            newLines.push(line)
          }
        }
        actionLog.operationParams = newLines.join('\n')
        if (actionLog.operationSource === LOG_BOOKING_CUSTOM_FORM.code && actionLog.operationJson) {
          customFormKeys.push(actionLog.operationJson.customFormUuid)
        }
      }
    }
    if (customFormKeys.length > 0) {
      const res = await queryUiCustomNameByKeys(customFormKeys)
      for (const actionLog of actionLogs) {
        if (actionLog.operationSource === LOG_BOOKING_CUSTOM_FORM.code && actionLog.operationJson) {
          actionLog.operationJson.customFormName = res.data[actionLog.operationJson.customFormUuid]
        }
      }
    }
  }

  static getOperationTypeName(operationType) {
    if (operationType === LOG_OPERATION_TYPE_DELETE.code) {
      return lang.t('SeaExport.Delete')
    }
    if (operationType === LOG_OPERATION_TYPE_ADD.code) {
      return lang.t('SeaExport.New')
    }
    if (operationType === LOG_OPERATION_TYPE_UPDATE.code) {
      return lang.t('SeaExport.Modify')
    }
  }

  static async getOperationSourceNameTab(item) {
    const operationSourceNameObj = operationSourceNameMap.get(item.operationSource)
    if (operationSourceNameObj) {
      if (typeof operationSourceNameObj.fullName === 'function') {
        return await operationSourceNameObj.fullName(item)
      } else {
        return operationSourceNameObj.fullName
      }
    }
    return ''
  }

  static async getOperationSourceNameDialog(item) {
    const operationSourceNameObj = operationSourceNameMap.get(item.operationSource)
    if (operationSourceNameObj) {
      if (typeof operationSourceNameObj.simpleName === 'function') {
        return await operationSourceNameObj.simpleName(item)
      } else {
        return operationSourceNameObj.simpleName
      }
    }
    return ''
  }
}
